// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { SpellingPagesDialogComponent } from '@client/app/pages/qa/spellcheck/pages/spelling-pages-dialog.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'spelling-dashboard-misspellings',
    standalone: false,
    template: `
        <div class="card panel-monsido-card">
            <mon-panel-header [pHeader]="header"></mon-panel-header>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-48 col-lg-48 col-48 inner-r-large inner-l-large">
                        <table-container
                                [progress]="promise"
                                [collection]="spellingErrors"
                                [noResultMessage]="'Good job! No issues were found' | translate">
                            <table class="table table-hover remove-first-row-border table-fixed">
                                <tbody>
                                <tr *ngFor="let spelling of spellingErrors; trackBy: trackBy">
                                    <td class="col-lg-18 text-v-middle" [attr.aria-label]="'Misspelling' | translate">
                                        <mon-spelling-classification
                                                [word]="spelling.word"
                                                [type]="spelling.classification">
                                        </mon-spelling-classification>
                                    </td>
                                    <td class="text-v-middle col-lg-8" [attr.aria-label]="'Language' | translate">
                                        <language [language]="spelling.language"></language>
                                    </td>
                                    <td class="text-left text-v-middle col-lg-8" [attr.aria-label]="'Show pages' | translate">
                                        <pages-button
                                                (callback)="openDialog(spelling)"
                                                [(ngModel)]="spelling.html_pages_count"
                                                name="html_pages_count">
                                        </pages-button>
                                    </td>
                                    <td class="text-right text-v-middle col-lg-8" [attr.aria-label]="'Add to dictionary' | translate">
                                        <table-dictionary
                                                (callback)="getPage()"
                                                [word]="spelling.word"
                                                [language]="spelling.language"
                                                [classification]="spelling.classification"
                                                [wordId]="spelling.id"
                                        >
                                        </table-dictionary>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </table-container>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class SpellingDashboardMisspellingsComponent extends BaseContainerComponentController implements OnInit {
    @Input() classification: any;
    @Input() header: any;

    spellingErrors: any[] = [];
    promise: any;

    constructor (
        private monEventService: MonEventService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.spellingErrors = [];
        this.getPage();
    }

    trackBy (index: number, item: any): any {
        return index;
    }

    override getPage = () => {
        const params = {
            page: 1,
            page_size: 5,
            sort_by: 'html_pages_count',
            classification: this.classification,
            page_fixed: false,
        };

        this.promise = this.spellingRepoService.getAllErrors(params).then((data: any) => {
            this.spellingErrors = data;
        }, () => {});
    };

    openDialog (word: any) {
        const params = {
            body: SpellingPagesDialogComponent,
            size: 'lg',
            data: {
                word: word,
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
